import React from "react";
import {LlmRunForComparison} from "common/flowmaster/types/llm_run";
import styled from "styled-components";
import TitleRowTd from "./title_row_td";
import OutputCell from "./output_cell";

interface OutputRowsProps {
  llmRuns: LlmRunForComparison[];
  outputKeys: string[];
  shownOutputs: string[];
  handleShownOutputsChange: (outputs: string[]) => void;
  title?: string;
  idPrefix?: "outputs" | "results";
  dataKey?: "output" | "results";
}

const OutputKey = styled.td`
  &:hover {
    cursor: pointer;
  }
`;

export default function OutputRows({
  llmRuns,
  outputKeys,
  shownOutputs,
  handleShownOutputsChange,
  title = "Outputs",
  idPrefix = "outputs",
  dataKey = "output",
}: OutputRowsProps) {
  const handleOutputRowClick = outputKey => {
    const outputKeyIndex = shownOutputs.indexOf(outputKey);
    if (outputKeyIndex === -1) {
      handleShownOutputsChange([...shownOutputs, outputKey]);
    } else {
      handleShownOutputsChange(
        shownOutputs.filter((item, index) => index !== outputKeyIndex),
      );
    }
  };

  const hiddenOutputs = outputKeys.filter(key => !shownOutputs.includes(key));
  const keyDisplayOrder = [...shownOutputs.sort(), ...hiddenOutputs.sort()];

  return (
    <>
      <tr id={idPrefix}>
        <TitleRowTd>{title}</TitleRowTd>
        {llmRuns.map(run => (
          <TitleRowTd key={`outputTitleTd_${run.id}`}></TitleRowTd>
        ))}
      </tr>
      {keyDisplayOrder.map(outputKey => {
        const hidden = hiddenOutputs.includes(outputKey);
        return (
          <>
            <tr
              key={`${idPrefix}.${outputKey}`}
              style={{verticalAlign: "top"}}
              id={`outputs.${outputKey}`}
            >
              <OutputKey
                onClick={() => handleOutputRowClick(outputKey)}
                style={hidden ? {color: "grey"} : {}}
              >
                {outputKey}
              </OutputKey>
              {llmRuns.map(run => {
                const runOutputValue =
                  run.data.data_store[dataKey]?.[outputKey] ?? "-";
                const testResults = run.results[dataKey]?.[outputKey];
                return (
                  <OutputCell
                    key={`${idPrefix}.${outputKey}.${run.id}`}
                    runId={run.id}
                    value={runOutputValue}
                    testResults={testResults}
                    hidden={hidden}
                    maxHeight="20em"
                  />
                );
              })}
            </tr>
          </>
        );
      })}
    </>
  );
}
